<!-- ═══════════════════════════════════════════════════════════════════════════
     Section: KINETIC ARCHITECTURE — infrastructure
  ════════════════════════════════════════════════════════════════════════════ -->
<section class="infra" aria-labelledby="infra-heading" id="protocol">

    <!-- Top + bottom fade overlays -->
    <div class="infra__fade infra__fade--top" aria-hidden="true"></div>
    <div class="infra__fade infra__fade--bottom" aria-hidden="true"></div>

    <div class="infra__container">
        <div class="infra__grid">

            <!-- ─── Left column ──────────────────────────────────────────────────── -->
            <div class="infra__left">
                <p class="infra__eyebrow">{{ 'infra.eyebrow' | translate }}</p>

                <h2 class="infra__title" id="infra-heading">
                    <span>{{ 'infra.title_1' | translate }}</span>
                    <span class="infra__title--accent">{{ 'infra.title_2' | translate }}</span>
                </h2>

                <p class="infra__body">{{ 'infra.body' | translate }}</p>

                <!-- Feature rows -->
                @for (feat of infraFeatures; track feat.titleKey; let i = $index) {
                <div class="infra__feature" [style.--glow]="feat.glowColor">
                    <div class="infra__feature-icon icon-{{i+1}}" aria-hidden="true">
                        <!-- TODO: replace with infra-icon.png when asset is confirmed -->
                        <img src="{{ feat.icon }}" alt="icons" loading="lazy" onerror="this.style.display='none'" />
                    </div>
                    <div class="infra__feature-text">
                        <strong class="infra__feature-title">{{ feat.titleKey | translate }}</strong>
                        <span class="infra__feature-sub">{{ feat.subKey | translate }}</span>
                    </div>
                </div>
                }
            </div>

            <!-- ─── Right column: 2×2 + wide card ───────────────────────────────── -->
            <div class="infra__right">
                <div class="infra__cards-top">

                    <!-- Binary Ops -->
                    <article class="infra__card">
                        <h3 class="infra__card-title">{{ 'infra.card1_title' | translate }}</h3>
                        <p class="infra__card-body">{{ 'infra.card1_body' | translate }}</p>
                        <div class="infra__card-stat">
                            <strong class="infra__card-stat-value infra__card-stat-value--cyan">
                                {{ 'infra.card1_stat' | translate }}
                            </strong>
                            <span class="infra__card-stat-label">{{ 'infra.card1_stat_label' | translate }}</span>
                        </div>
                    </article>

                    <!-- World Events -->
                    <article class="infra__card">
                        <h3 class="infra__card-title">{{ 'infra.card2_title' | translate }}</h3>
                        <p class="infra__card-body">{{ 'infra.card2_body' | translate }}</p>
                        <div class="infra__card-stat">
                            <strong class="infra__card-stat-value infra__card-stat-value--lime">
                                {{ 'infra.card2_stat' | translate }}
                            </strong>
                            <span class="infra__card-stat-label">{{ 'infra.card2_stat_label' | translate }}</span>
                        </div>
                    </article>
                </div>

                <!-- Vault Liquidity Staking — wide card -->
                <article class="infra__card infra__card--wide">
                    <div class="infra__card-wide-text">
                        <h3 class="infra__card-title">{{ 'infra.card3_title' | translate }}</h3>
                        <p class="infra__card-body">{{ 'infra.card3_body' | translate }}</p>
                    </div>

                    <!-- Terminal readout -->
                    <div class="infra__terminal" aria-label="Vault data terminal">
                        <div class="infra__terminal-row">
                            <span class="infra__terminal-key">{{ 'infra.vault_id' | translate }}</span>
                            <span class="infra__terminal-val infra__terminal-val--lime">{{ 'infra.vault_status' |
                                translate }}</span>
                        </div>
                        <div class="infra__terminal-row">
                            <span class="infra__terminal-key">{{ 'infra.vault_apy_label' | translate }}</span>
                            <span class="infra__terminal-val infra__terminal-val--lime">{{ 'infra.vault_apy_value' |
                                translate }}</span>
                        </div>
                        <div class="infra__terminal-row">
                            <span class="infra__terminal-key">{{ 'infra.vault_tvl_label' | translate }}</span>
                            <span class="infra__terminal-val infra__terminal-val--white">{{ 'infra.vault_tvl_value' |
                                translate }}</span>
                        </div>
                    </div>
                </article>
                <button  (click)="buyNow()" class="btn buy-cta-btn btn-primary font-14">{{
                    "infra.get_access" | translate }}</button>
            </div>

        </div>
    </div>
</section>